import { Injectable } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import { GenericRequestHandlerService } from '../../core/services/generic-request-handler.service';
import { MailingService, MyLibraryService } from '../../api';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CreateMessageService {

    private selectedMakes = {};
    private selectedDocuments = {};

    constructor(
        private genericRequestHandler: GenericRequestHandlerService,
        private myLibraryService: MyLibraryService,
        private api: MailingService
    ) { }

    public getMakesListObservable() {
        return this.api.accountBrandsListQuery();
    }

    public getDocumentsListObservable() {
        return this.api.accountBrandsListQuery().pipe(
            map(data => {
                return {
                    data: data.data.filter(item => this.selectedMakes[item.id]),
                }
            })
        );
    }
    public getMyDocumentsListObservable() {
        return this.myLibraryService.myDocumentListQuery();
    }

    public sendMessage(addresses: Array<string>, customMessage?: string) {
        const content = {
            emailAddresses: addresses,
            documentIds: [],
            privateDocumentIds: [],
            customMessage: customMessage || '',
        }

        for (let selectedDocumentsKey in this.selectedDocuments) {
            if (this.selectedDocuments[selectedDocumentsKey]) {
                if (selectedDocumentsKey.indexOf('MYDOC_') !== -1) {
                    // plik z mojej biblioteki
                    content.privateDocumentIds.push(selectedDocumentsKey.replace('MYDOC_', ''));
                } else {
                    // zwykly plik
                    content.documentIds.push(selectedDocumentsKey);
                }
            }
        }

        return this.genericRequestHandler.callRequest(
            this.api.mailingHandler(content),
            'Dokumenty wysłane'
        );
    }

    public clearSelection() {
        this.selectedMakes = {};
        this.selectedDocuments = {};
    }

    public saveMakesSelection(model) {
        this.selectedMakes = model;
    }
    public getMakesSelection() {
        return this.selectedMakes;
    }

    public saveDocumentsSelection(model) {
        this.selectedDocuments = model;
    }
    public getDocumentsSelection() {
        return this.selectedDocuments;
    }
}
